// Generated by `yarn tokens:import` from the Figma mirror. Do not edit.
//
// The resolved palette per tenant, as literals. It exists so the tenant theme
// files hold no colour values of their own: `yarn env` copies one of them to
// tmp/colors.ts as the app's runtime palette, and a copy that could be edited
// by hand is a second source of truth waiting to disagree with Tailwind.

export const tenantPalettes = {
    aoims: {
        'action': {
            'default': '#FFDD4F',
            'focus-ring': '#FFDD4F',
            'grey-action': '#8F8F92',
            'grey-action-hover': '#9B9B9E',
            'hover': '#FFEC61',
            'overlay-action': '#ECEEF5',
            'overlay-action-hover': '#E2E4EB',
            'overlay-action-pressed': '#D5D7DE',
            'pressed': '#F0CE3C',
        },
        'aos-bg': {
            'canvas': '#111114',
            'canvas-hover': '#1B1B1E',
            'canvas-pressed': '#0A0A0D',
            'elevation': '#262629',
            'elevation-hover': '#303033',
            'elevation-pressed': '#1F1F22',
            'highlight': '#2D2D30',
            'highlight-hover': '#37373A',
            'highlight-pressed': '#232326',
            'hover-layer': '#29292C',
            'input': '#111114',
            'input-hover': '#1B1B1E',
            'input-pressed': '#0E0E10',
            'sub-surface': '#18181B',
            'sub-surface-hover': '#222129',
            'sub-surface-pressed': '#111114',
            'surface': '#1F1F22',
            'surface-hover': '#29292C',
            'surface-pressed': '#18181B',
            'white': '#FFFFFF',
        },
        'aos-primary': {
            border: '#615823',
            default: '#FFDD4F',
            hover: '#FFEC61',
            pressed: '#F0CE3C',
            surface: '#272417',
        },
        'aos-text': {
            'default': '#E5E5E6',
            'destructive': '#FF4529',
            'disabled': '#8F8F92',
            'knockout': '#FFFFFF',
            'link': '#7BBCFF',
            'link-hover': '#A0D2FF',
            'link-pressed': '#6FB2FC',
            'link-visited': '#BFA6FE',
            'logotype': '#FFFFFF',
            'muted': '#ACADAF',
            'on-action': '#2B2B2B',
            'on-graphics': '#2B2B2B',
            'on-primary': '#2B2B2B',
        },
        'background': {
            'canvas': '#111114',
            'canvas-hover': '#1B1B1E',
            'canvas-pressed': '#0A0A0D',
            'elevation': '#262629',
            'elevation-hover': '#303033',
            'elevation-pressed': '#1F1F22',
            'highlight': '#2D2D30',
            'highlight-hover': '#37373A',
            'highlight-pressed': '#232326',
            'input': '#111114',
            'input-hover': '#1B1B1E',
            'sub-surface': '#18181B',
            'sub-surface-hover': '#222129',
            'sub-surface-pressed': '#111114',
            'surface': '#1F1F22',
            'surface-hover': '#29292C',
            'surface-pressed': '#18181B',
        },
        'border': {
            message: '#405088',
            overlay: '#AFB1B8',
            strong: '#505051',
            subtle: '#2A2D32',
            transparent: '#00000000',
        },
        'charts': {
            'apron-temperature': '#95BD63',
            'dew-point': '#EA9858',
            'level-1': '#6FB2FC',
            'level-2': '#08C6C8',
            'level-3': '#B59CF5',
            'level-4': '#E68CC2',
            'rain': '#6FB2FC',
            'rain-snow': '#B59CF5',
            'snow': '#08C6C8',
            'temperature': '#BBBDC4',
            'wind': '#BBBDC4',
        },
        'content': {
            'default': '#E5E5E6',
            'destructive': '#FF4529',
            'inverted': '#2B2B2B',
            'knockout': '#FFFFFF',
            'link': '#7BBCFF',
            'link-hover': '#A0D2FF',
            'link-pressed': '#6FB2FC',
            'link-visited': '#BFA6FE',
            'logotype': '#FFFFFF',
            'muted': '#ACADAF',
            'on-action': '#2B2B2B',
            'on-primary': '#2B2B2B',
        },
        'destructive': {
            border: '#FF4529',
            default: '#E72400',
            hover: '#DC2100',
            pressed: '#D01F00',
        },
        'flights': {
            'arrivals': '#EA9858',
            'arrivals-local': '#AC672D',
            'arrivals-transfer': '#351A03',
            'cancelled': '#A95D8B',
            'delayed': '#816BB6',
            'departures': '#8DAAFF',
            'departures-local': '#5E76BE',
            'departures-transfer': '#17203C',
            'on-time': '#606063',
        },
        'focus': {
            ring: '#FFDD4F',
        },
        'graphics': {
            'blue': '#6FB2FC',
            'blue-hover': '#7BBCFF',
            'blue-light': '#0B233B',
            'blue-medium': '#437DBC',
            'blue-pressed': '#63A5EE',
            'dark-grey': '#606063',
            'dark-grey-hover': '#6B6B6F',
            'dark-grey-pressed': '#555558',
            'green': '#79C379',
            'green-hover': '#84CC84',
            'green-pressed': '#6DB66D',
            'grey': '#8F8F92',
            'grey-hover': '#9B9B9E',
            'grey-pressed': '#838386',
            'indigo': '#8DAAFF',
            'indigo-hover': '#97B4FF',
            'indigo-light': '#17203C',
            'indigo-medium': '#5E76BE',
            'indigo-pressed': '#819DF1',
            'lavender': '#BF99EF',
            'lavender-hover': '#C8A3F8',
            'lavender-pressed': '#B38DE2',
            'lime': '#95BD63',
            'lime-hover': '#9FC76E',
            'lime-pressed': '#89B156',
            'orange': '#EA9858',
            'orange-hover': '#F3A264',
            'orange-light': '#351A03',
            'orange-medium': '#AC672D',
            'orange-pressed': '#DC8C4B',
            'pink': '#E68CC2',
            'pink-hover': '#EF96CB',
            'pink-light': '#331628',
            'pink-medium': '#A95D8B',
            'pink-pressed': '#D880B5',
            'red': '#F48D80',
            'red-hover': '#FD978A',
            'red-pressed': '#E68174',
            'silver': '#BBBDC4',
            'silver-hover': '#C8CAD1',
            'silver-light': '#2C2E33',
            'silver-medium': '#8D8F95',
            'silver-pressed': '#AFB1B8',
            'teal': '#08C6C8',
            'teal-hover': '#30CFD1',
            'teal-light': '#00292A',
            'teal-medium': '#008E91',
            'teal-pressed': '#00B9BB',
            'violet': '#B59CF5',
            'violet-hover': '#BFA6FE',
            'violet-light': '#241B39',
            'violet-medium': '#816BB6',
            'violet-pressed': '#A990E7',
            'yellow': '#D3A742',
            'yellow-hover': '#DCB151',
            'yellow-pressed': '#C69A33',
        },
        'primary': {
            border: '#615823',
            default: '#FFDD4F',
            hover: '#FFEC61',
            pressed: '#F0CE3C',
            surface: '#272417',
        },
        'status': {
            'caution': '#FF8B1F',
            'caution-hover': '#FFA23F',
            'caution-pressed': '#EF7D00',
            'critical': '#E72400',
            'critical-hover': '#DC2100',
            'critical-pressed': '#D01F00',
            'info': '#629BFF',
            'info-hover': '#6EA8FF',
            'info-pressed': '#558DEF',
            'neutral': '#9DB0C7',
            'neutral-hover': '#ABBED5',
            'neutral-muted': '#232D43',
            'neutral-pressed': '#8FA2B8',
            'success': '#54CC49',
            'success-hover': '#64DC58',
            'success-pressed': '#44BD38',
            'warning': '#F8D41D',
            'warning-hover': '#FFE339',
            'warning-pressed': '#E9C500',
        },
        'status-muted': {
            caution: 'rgba(255,139,31,0.15)',
            critical: 'rgba(231,36,0,0.15)',
            info: 'rgba(98,155,255,0.15)',
            neutral: 'rgba(157,176,199,0.15)',
            success: 'rgba(84,204,73,0.15)',
            warning: 'rgba(248,212,29,0.15)',
        },
        'surface': {
            'card': '#262629',
            'highlight': '#2D2D30',
            'highlight-hover': '#37373A',
            'input': '#111114',
            'message': '#24315E',
            'raised': '#262629',
            'subtle': '#18181B',
        },
        'waiting-time': {
            'border-arrivals': '#B59CF5',
            'border-departures': '#F48D80',
            'security-departures': '#6FB2FC',
            'security-transfer': '#08C6C8',
        },
    },
    aos: {
        'action': {
            'default': '#005DE5',
            'focus-ring': '#005DE5',
            'grey-action': '#8F8F92',
            'grey-action-hover': '#9B9B9E',
            'hover': '#0C6BFA',
            'overlay-action': '#ECEEF5',
            'overlay-action-hover': '#E2E4EB',
            'overlay-action-pressed': '#D5D7DE',
            'pressed': '#0050CF',
        },
        'aos-bg': {
            'canvas': '#111114',
            'canvas-hover': '#1B1B1E',
            'canvas-pressed': '#0A0A0D',
            'elevation': '#262629',
            'elevation-hover': '#303033',
            'elevation-pressed': '#1F1F22',
            'highlight': '#2D2D30',
            'highlight-hover': '#37373A',
            'highlight-pressed': '#232326',
            'hover-layer': '#29292C',
            'input': '#111114',
            'input-hover': '#1B1B1E',
            'input-pressed': '#0E0E10',
            'sub-surface': '#18181B',
            'sub-surface-hover': '#222129',
            'sub-surface-pressed': '#111114',
            'surface': '#1F1F22',
            'surface-hover': '#29292C',
            'surface-pressed': '#18181B',
            'white': '#FFFFFF',
        },
        'aos-primary': {
            border: '#3254A7',
            default: '#005DE5',
            hover: '#0C6BFA',
            pressed: '#0050CF',
            surface: '#16347A',
        },
        'aos-text': {
            'default': '#E5E5E6',
            'destructive': '#FF4529',
            'disabled': '#8F8F92',
            'knockout': '#FFFFFF',
            'link': '#7BBCFF',
            'link-hover': '#A0D2FF',
            'link-pressed': '#6FB2FC',
            'link-visited': '#BFA6FE',
            'logotype': '#FFFFFF',
            'muted': '#ACADAF',
            'on-action': '#ECF1F8',
            'on-graphics': '#2B2B2B',
            'on-primary': '#ECF1F8',
        },
        'background': {
            'canvas': '#111114',
            'canvas-hover': '#1B1B1E',
            'canvas-pressed': '#0A0A0D',
            'elevation': '#262629',
            'elevation-hover': '#303033',
            'elevation-pressed': '#1F1F22',
            'highlight': '#2D2D30',
            'highlight-hover': '#37373A',
            'highlight-pressed': '#232326',
            'input': '#111114',
            'input-hover': '#1B1B1E',
            'sub-surface': '#18181B',
            'sub-surface-hover': '#222129',
            'sub-surface-pressed': '#111114',
            'surface': '#1F1F22',
            'surface-hover': '#29292C',
            'surface-pressed': '#18181B',
        },
        'border': {
            message: '#405088',
            overlay: '#AFB1B8',
            strong: '#505051',
            subtle: '#2A2D32',
            transparent: '#00000000',
        },
        'charts': {
            'apron-temperature': '#95BD63',
            'dew-point': '#EA9858',
            'level-1': '#6FB2FC',
            'level-2': '#08C6C8',
            'level-3': '#B59CF5',
            'level-4': '#E68CC2',
            'rain': '#6FB2FC',
            'rain-snow': '#B59CF5',
            'snow': '#08C6C8',
            'temperature': '#BBBDC4',
            'wind': '#BBBDC4',
        },
        'content': {
            'default': '#E5E5E6',
            'destructive': '#FF4529',
            'inverted': '#2B2B2B',
            'knockout': '#FFFFFF',
            'link': '#7BBCFF',
            'link-hover': '#A0D2FF',
            'link-pressed': '#6FB2FC',
            'link-visited': '#BFA6FE',
            'logotype': '#FFFFFF',
            'muted': '#ACADAF',
            'on-action': '#ECF1F8',
            'on-primary': '#ECF1F8',
        },
        'destructive': {
            border: '#FF4529',
            default: '#E72400',
            hover: '#DC2100',
            pressed: '#D01F00',
        },
        'flights': {
            'arrivals': '#EA9858',
            'arrivals-local': '#AC672D',
            'arrivals-transfer': '#351A03',
            'cancelled': '#A95D8B',
            'delayed': '#816BB6',
            'departures': '#8DAAFF',
            'departures-local': '#5E76BE',
            'departures-transfer': '#17203C',
            'on-time': '#606063',
        },
        'focus': {
            ring: '#005DE5',
        },
        'graphics': {
            'blue': '#6FB2FC',
            'blue-hover': '#7BBCFF',
            'blue-light': '#0B233B',
            'blue-medium': '#437DBC',
            'blue-pressed': '#63A5EE',
            'dark-grey': '#606063',
            'dark-grey-hover': '#6B6B6F',
            'dark-grey-pressed': '#555558',
            'green': '#79C379',
            'green-hover': '#84CC84',
            'green-pressed': '#6DB66D',
            'grey': '#8F8F92',
            'grey-hover': '#9B9B9E',
            'grey-pressed': '#838386',
            'indigo': '#8DAAFF',
            'indigo-hover': '#97B4FF',
            'indigo-light': '#17203C',
            'indigo-medium': '#5E76BE',
            'indigo-pressed': '#819DF1',
            'lavender': '#BF99EF',
            'lavender-hover': '#C8A3F8',
            'lavender-pressed': '#B38DE2',
            'lime': '#95BD63',
            'lime-hover': '#9FC76E',
            'lime-pressed': '#89B156',
            'orange': '#EA9858',
            'orange-hover': '#F3A264',
            'orange-light': '#351A03',
            'orange-medium': '#AC672D',
            'orange-pressed': '#DC8C4B',
            'pink': '#E68CC2',
            'pink-hover': '#EF96CB',
            'pink-light': '#331628',
            'pink-medium': '#A95D8B',
            'pink-pressed': '#D880B5',
            'red': '#F48D80',
            'red-hover': '#FD978A',
            'red-pressed': '#E68174',
            'silver': '#BBBDC4',
            'silver-hover': '#C8CAD1',
            'silver-light': '#2C2E33',
            'silver-medium': '#8D8F95',
            'silver-pressed': '#AFB1B8',
            'teal': '#08C6C8',
            'teal-hover': '#30CFD1',
            'teal-light': '#00292A',
            'teal-medium': '#008E91',
            'teal-pressed': '#00B9BB',
            'violet': '#B59CF5',
            'violet-hover': '#BFA6FE',
            'violet-light': '#241B39',
            'violet-medium': '#816BB6',
            'violet-pressed': '#A990E7',
            'yellow': '#D3A742',
            'yellow-hover': '#DCB151',
            'yellow-pressed': '#C69A33',
        },
        'primary': {
            border: '#3254A7',
            default: '#005DE5',
            hover: '#0C6BFA',
            pressed: '#0050CF',
            surface: '#16347A',
        },
        'status': {
            'caution': '#FF8B1F',
            'caution-hover': '#FFA23F',
            'caution-pressed': '#EF7D00',
            'critical': '#E72400',
            'critical-hover': '#DC2100',
            'critical-pressed': '#D01F00',
            'info': '#629BFF',
            'info-hover': '#6EA8FF',
            'info-pressed': '#558DEF',
            'neutral': '#9DB0C7',
            'neutral-hover': '#ABBED5',
            'neutral-muted': '#232D43',
            'neutral-pressed': '#8FA2B8',
            'success': '#54CC49',
            'success-hover': '#64DC58',
            'success-pressed': '#44BD38',
            'warning': '#F8D41D',
            'warning-hover': '#FFE474',
            'warning-pressed': '#E9C500',
        },
        'status-muted': {
            caution: 'rgba(255,139,31,0.15)',
            critical: 'rgba(231,36,0,0.15)',
            info: 'rgba(98,155,255,0.15)',
            neutral: 'rgba(157,176,199,0.15)',
            success: 'rgba(84,204,73,0.15)',
            warning: 'rgba(248,212,29,0.15)',
        },
        'surface': {
            'card': '#262629',
            'highlight': '#2D2D30',
            'highlight-hover': '#37373A',
            'input': '#111114',
            'message': '#24315E',
            'raised': '#262629',
            'subtle': '#18181B',
        },
        'waiting-time': {
            'border-arrivals': '#B59CF5',
            'border-departures': '#F48D80',
            'security-departures': '#6FB2FC',
            'security-transfer': '#08C6C8',
        },
    },
    swedavia: {
        'action': {
            'default': '#3192D0',
            'focus-ring': '#3192D0',
            'grey-action': '#8F8F92',
            'grey-action-hover': '#9B9B9E',
            'hover': '#26AAED',
            'overlay-action': '#FFFFFF',
            'overlay-action-hover': '#FFFFFF',
            'overlay-action-pressed': '#FFFFFF',
            'pressed': '#008ECF',
        },
        'aos-bg': {
            'canvas': '#111114',
            'canvas-hover': '#1B1B1E',
            'canvas-pressed': '#0A0A0D',
            'elevation': '#262629',
            'elevation-hover': '#303033',
            'elevation-pressed': '#1F1F22',
            'highlight': '#2D2D30',
            'highlight-hover': '#37373A',
            'highlight-pressed': '#232326',
            'hover-layer': '#29292C',
            'input': '#111114',
            'input-hover': '#1B1B1E',
            'input-pressed': '#0E0E10',
            'sub-surface': '#18181B',
            'sub-surface-hover': '#222129',
            'sub-surface-pressed': '#111114',
            'surface': '#1F1F22',
            'surface-hover': '#29292C',
            'surface-pressed': '#18181B',
            'white': '#FFFFFF',
        },
        'aos-primary': {
            border: '#008ACB',
            default: '#3192D0',
            hover: '#26AAED',
            pressed: '#008ECF',
            surface: '#1F3D50',
        },
        'aos-text': {
            'default': '#E5E5E6',
            'destructive': '#FF4529',
            'disabled': '#8F8F92',
            'knockout': '#FFFFFF',
            'link': '#7BBCFF',
            'link-hover': '#A0D2FF',
            'link-pressed': '#6FB2FC',
            'link-visited': '#BFA6FE',
            'logotype': '#FFFFFF',
            'muted': '#ACADAF',
            'on-action': '#2B2B2B',
            'on-graphics': '#2B2B2B',
            'on-primary': '#2B2B2B',
        },
        'background': {
            'canvas': '#111114',
            'canvas-hover': '#1B1B1E',
            'canvas-pressed': '#0A0A0D',
            'elevation': '#262629',
            'elevation-hover': '#303033',
            'elevation-pressed': '#1F1F22',
            'highlight': '#2D2D30',
            'highlight-hover': '#37373A',
            'highlight-pressed': '#232326',
            'input': '#111114',
            'input-hover': '#1B1B1E',
            'sub-surface': '#18181B',
            'sub-surface-hover': '#222129',
            'sub-surface-pressed': '#111114',
            'surface': '#1F1F22',
            'surface-hover': '#29292C',
            'surface-pressed': '#18181B',
        },
        'border': {
            message: '#405088',
            overlay: '#FFFFFF',
            strong: '#505051',
            subtle: '#2A2D32',
            transparent: '#00000000',
        },
        'charts': {
            'apron-temperature': '#95BD63',
            'dew-point': '#EA9858',
            'level-1': '#6FB2FC',
            'level-2': '#08C6C8',
            'level-3': '#B59CF5',
            'level-4': '#E68CC2',
            'rain': '#6FB2FC',
            'rain-snow': '#B59CF5',
            'snow': '#08C6C8',
            'temperature': '#BBBDC4',
            'wind': '#BBBDC4',
        },
        'content': {
            'default': '#E5E5E6',
            'destructive': '#FF4529',
            'inverted': '#2B2B2B',
            'knockout': '#FFFFFF',
            'link': '#7BBCFF',
            'link-hover': '#A0D2FF',
            'link-pressed': '#6FB2FC',
            'link-visited': '#BFA6FE',
            'logotype': '#FFFFFF',
            'muted': '#ACADAF',
            'on-action': '#2B2B2B',
            'on-primary': '#2B2B2B',
        },
        'destructive': {
            border: '#FF4529',
            default: '#E72400',
            hover: '#DC2100',
            pressed: '#D01F00',
        },
        'flights': {
            'arrivals': '#EA9858',
            'arrivals-local': '#AC672D',
            'arrivals-transfer': '#351A03',
            'cancelled': '#A95D8B',
            'delayed': '#816BB6',
            'departures': '#8DAAFF',
            'departures-local': '#5E76BE',
            'departures-transfer': '#17203C',
            'on-time': '#606063',
        },
        'focus': {
            ring: '#3192D0',
        },
        'graphics': {
            'blue': '#6FB2FC',
            'blue-hover': '#7BBCFF',
            'blue-light': '#0B233B',
            'blue-medium': '#437DBC',
            'blue-pressed': '#63A5EE',
            'dark-grey': '#606063',
            'dark-grey-hover': '#6B6B6F',
            'dark-grey-pressed': '#555558',
            'green': '#79C379',
            'green-hover': '#84CC84',
            'green-pressed': '#6DB66D',
            'grey': '#8F8F92',
            'grey-hover': '#9B9B9E',
            'grey-pressed': '#838386',
            'indigo': '#8DAAFF',
            'indigo-hover': '#97B4FF',
            'indigo-light': '#17203C',
            'indigo-medium': '#5E76BE',
            'indigo-pressed': '#819DF1',
            'lavender': '#BF99EF',
            'lavender-hover': '#C8A3F8',
            'lavender-pressed': '#B38DE2',
            'lime': '#95BD63',
            'lime-hover': '#9FC76E',
            'lime-pressed': '#89B156',
            'orange': '#EA9858',
            'orange-hover': '#F3A264',
            'orange-light': '#351A03',
            'orange-medium': '#AC672D',
            'orange-pressed': '#DC8C4B',
            'pink': '#E68CC2',
            'pink-hover': '#EF96CB',
            'pink-light': '#331628',
            'pink-medium': '#A95D8B',
            'pink-pressed': '#D880B5',
            'red': '#F48D80',
            'red-hover': '#FD978A',
            'red-pressed': '#E68174',
            'silver': '#BBBDC4',
            'silver-hover': '#C8CAD1',
            'silver-light': '#2C2E33',
            'silver-medium': '#8D8F95',
            'silver-pressed': '#AFB1B8',
            'teal': '#08C6C8',
            'teal-hover': '#30CFD1',
            'teal-light': '#00292A',
            'teal-medium': '#008E91',
            'teal-pressed': '#00B9BB',
            'violet': '#B59CF5',
            'violet-hover': '#BFA6FE',
            'violet-light': '#241B39',
            'violet-medium': '#816BB6',
            'violet-pressed': '#A990E7',
            'yellow': '#D3A742',
            'yellow-hover': '#DCB151',
            'yellow-pressed': '#C69A33',
        },
        'primary': {
            border: '#008ACB',
            default: '#3192D0',
            hover: '#26AAED',
            pressed: '#008ECF',
            surface: '#1F3D50',
        },
        'status': {
            'caution': '#FF8B1F',
            'caution-hover': '#FFA23F',
            'caution-pressed': '#EF7D00',
            'critical': '#E72400',
            'critical-hover': '#DC2100',
            'critical-pressed': '#D01F00',
            'info': '#629BFF',
            'info-hover': '#6EA8FF',
            'info-pressed': '#558DEF',
            'neutral': '#9DB0C7',
            'neutral-hover': '#ABBED5',
            'neutral-muted': '#232D43',
            'neutral-pressed': '#8FA2B8',
            'success': '#54CC49',
            'success-hover': '#64DC58',
            'success-pressed': '#44BD38',
            'warning': '#F8D41D',
            'warning-hover': '#FFE64E',
            'warning-pressed': '#E9C500',
        },
        'status-muted': {
            caution: 'rgba(255,139,31,0.15)',
            critical: 'rgba(231,36,0,0.15)',
            info: 'rgba(98,155,255,0.15)',
            neutral: 'rgba(157,176,199,0.15)',
            success: 'rgba(84,204,73,0.15)',
            warning: 'rgba(248,212,29,0.15)',
        },
        'surface': {
            'card': '#262629',
            'highlight': '#2D2D30',
            'highlight-hover': '#37373A',
            'input': '#111114',
            'message': '#24315E',
            'raised': '#262629',
            'subtle': '#18181B',
        },
        'waiting-time': {
            'border-arrivals': '#B59CF5',
            'border-departures': '#F48D80',
            'security-departures': '#6FB2FC',
            'security-transfer': '#08C6C8',
        },
    },
} as const

export type TenantPaletteName = keyof typeof tenantPalettes
